export const publicStorageURL =
  "https://storage.googleapis.com/yardzen-public-assets/client-app";

export enum SegmentForms {
  FREE_PROJECT_PLANNER_SIGN_UP = "Free Project Planner Sign Up",
  SIGN_UP_AND_MESSAGE_PRO = "Sign Up and Message Pro",
  FREE_PROJECT_PLANNER_LOGIN = "Free Project Planner Login",
  FORGOT_PASSWORD = "Forgot Password",
  GALLERY_LIKES_LOGIN = "Gallery Likes Login",
  LEAD_CAPTURE = "Lead Capture",
  USER_PROFILE = "User Profile",
  STYLE_FINDER = "Style Finder",
  SELECT_PROJECT_FEATURES = "Select Project Features",
  PRO_MATCHES_LOGIN = "Pro Matches Login",
  CONTRACTOR_PROFILE_LOGIN = "Contractor Profile Login",
  SITEWALK_SCHEDULE = "Site Walk Schedule",
  INPSIRATION = "Inspiration",
  BUILD_STUDIO_SITE_WALK_FALLBACK = "Build Studio Site Walk Fallback",
  BUILD_STUDIO_SITE_WALK_CALENDLY = "Build Studio Site Walk Calendly",
  DESIGN_PROFILE_QUIZ = "Design Profile Quiz",
  CHECKOUT_PACKAGE_DETAILS = "Checkout Package Details",
  CHECKOUT_FORM = "Checkout Form",
  CHECKOUT_FORM_EXPRESS = "Checkout Form Express",
  ONBOARDING_PLANTS = "Onboarding Plants",
  ONBOARDING_GOALS = "Onboarding Goals",
  ONBOARDING_INSPIRATION = "Onboarding Inspiration",
  ONBOARDING_EXTERIOR = "Onboarding Exterior",
}

// See: https://yardzen.atlassian.net/browse/BUI-501
export enum SegmentFlows {
  SIGN_IN = "Sign In",
  SIGN_UP = "Sign Up",
  PRO_MATCHES = "Pro Matches", // /select-project-features
  FORGOT_PASSWORD = "Forgot Password",
  STYLE_FINDER = "Style Finder", // /style-finder
  TOP_NAV = "Top Nav",
  PRO_PROFILE = "Pro Profile",
  HOME = "Marketing Home",
  FOOTER = "Page Footer",
  BANNER = "Page Banner",
  BUILD_STUDIO_SITE_WALK = "Build Studio Site Walk",
  PACKAGES = "Packages",
  HOW_IT_WORKS = "How It Works",
  PRO_DESIGNS = "Pro Designs",
  PACKAGE_DETAIL_FULL_YARD = "Package Detail - Full Yard",
  PACKAGE_DETAIL_FRONT_YARD = "Package Detail - Front Yard",
  PACKAGE_DETAIL_BACK_YARD = "Package Detail - Back Yard",
  PACKAGE_DETAIL_CURB_APPEAL = "Package Detail - Curb Appeal",
  PACKAGE_DETAIL_OUTDOOR_TRANSFORMATION = "Package Detail - Outdoor Transformation",
  PACKAGE_DETAIL_BOTANICAL = "Package Detail - Botanical",
  PACKAGE_DETAIL_PREMIUM = "Package Detail - Premium",
  DESIGN_PROFILE_QUIZ = "Design Profile Quiz",
  CHECKOUT = "Checkout",
  FIVE_REASONS_TO_CHOOSE_YARDZEN = "5 Reasons to Choose Yardzen",
  CAREERS = "Careers",
  CONTRACTORS = "Contractors",
  FAQ = "Faq",
  PRIVACY_POLICY = "Privacy Policy",
  TERMS_CONDITIONS = "Terms And Conditions",

  // Studio McGee
  STUDIO_MCGEE = "Studio McGee",
  STUDIO_MCGEE_PACKAGE_DETAIL_FULL_YARD = "Studio McGee - Package Detail - Full Yard",
  STUDIO_MCGEE_PACKAGE_DETAIL_FRONT_YARD = "Studio McGee - Package Detail - Front Yard",
  STUDIO_MCGEE_PACKAGE_DETAIL_BACK_YARD = "Studio McGee - Package Detail - Back Yard",
  STUDIO_MCGEE_PACKAGE_DETAIL_CURB_APPEAL = "Studio McGee - Package Detail - Curb Appeal",
  STUDIO_MCGEE_PACKAGE_DETAIL_OUTDOOR_TRANSFORMATION = "Studio McGee - Package Detail - Outdoor Transformation",
  CONTENTFUL_SECTIONS = "Contentful Sections",
  ONBOARDING_PLANTS = "Onboarding Plants",
  ONBOARDING_GOALS = "Onboarding Goals",
  ONBOARDING_INSPIRATION = "Onboarding Inspiration",
  ONBOARDING_EXTERIOR = "Onboarding Exterior",
}

export enum SegmentSubFlows {
  LEAD_CAPTURE = "lead_capture",
}

export const YARDZEN_TERMS_AND_CONDITIONS_URL =
  "https://yardzen.com/terms-and-conditions";

export const GtmEvents = {
  DESIGN_PROFILE_QUIZ_STEP: "design_profile_step",
  DESIGN_PROFILE_QUIZ_STARTED: "design_profile_start",
  DESIGN_PROFILE_COMPLETE: "design_profile_complete",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
  AUTH_STATE_CHANGE: "auth_state_change",
  GENERATE_LEAD: "generate_lead",
};
